import { render, staticRenderFns } from "./OverdueBookingsWarning.vue?vue&type=template&id=60884100"
import script from "./OverdueBookingsWarning.vue?vue&type=script&lang=ts"
export * from "./OverdueBookingsWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports